import React, { useEffect, useState } from "react";
import { Collapse } from "antd";
import "./style.scss";
import { api } from "services/api";

export const HelpPage: React.FC = () => {
	const [questions, setQuestions] = useState<any[]>([]);
	const { Panel } = Collapse;

	useEffect(() => {
		api.get("/faq/active").then((res) => {
			setQuestions(res.data.data.questions);
		});
	}, []);

	return (
		<div className="help">
			<div className="help__container">
				<div className="help__container__title">
					<h1>Central de ajuda</h1>
					<p>
						Encontre aqui a solução correta parea as mais diversas dúvidas sobre
						nossa plataforma.
					</p>
				</div>
				<Collapse>
					{questions?.map((item, index) => {
						return (
							<Panel header={item.title} key={index}>
								<p>{item.Answers?.[0].content}</p>
							</Panel>
						);
					})}
				</Collapse>
			</div>
		</div>
	);
};
